import makeApiRequest from './makeApiCall';
//sales
export const getApprovers = async () => {
  return await makeApiRequest(`/lock/approver`, 'POST', null);
};

export const getValidities = async () => {
  return await makeApiRequest(`/lock/validity`, 'POST', null);
};

export const getUsers = async () => {
  return await makeApiRequest(`/users`, 'GET', null);
};

export const updateAdminAccess = async (payload) => {
  return await makeApiRequest(`/lock/approver/update`, 'POST', null, payload);
};

export const getTransactionRequests = async (payload) => {
  return await makeApiRequest(`/lock/request`, 'POST', null, payload);
};

export const getTransactionDropdown = async (payload) => {
  return await makeApiRequest(
    `/lock/request/transaction/reference`,
    'POST',
    null,
    payload,
  );
};

export const getEditableFields = async (payload) => {
  return await makeApiRequest(`/lock/request/fields`, 'POST', null, payload);
};

export const createTransactionRequest = async (payload) => {
  return await makeApiRequest(
    `lock/request/create`,
    'POST',
    null,
    payload,
    true,
  );
};

export const cancelRequest = async (payload) => {
  return await makeApiRequest(
    `/lock/request/cancel/update`,
    'POST',
    null,
    payload,
  );
};

export const getRequestByReference = async (payload) => {
  return await makeApiRequest(`/lock/request/reference`, 'POST', null, payload);
};

export const getAuditLockTransactions = async () => {
  return await makeApiRequest(`/lock/request/approved`, 'POST', null, null);
};

export const getUsersForAuditLock = async () => {
  return await makeApiRequest(`/audit/locking/users`, 'GET', null);
};
